module.exports = __webpack_public_path__ + "img/laurent.9dad1b87.svg";